export default {
  isDoneAll: (state) => {
    return state.list.every(item => item.get('done'))
  },

  notYetHabits: (state) => {
    return state.list.filter(item => !item.get('done'))
  }
}
